import { OrderTypeEnum, StyleWeighmentEnum } from "@gtpl/shared-models/enquiry-management";
import { Column, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn } from "typeorm";
import { EnquiriesEntity } from "./enquiries";
import { CostSheetEntity } from "../../costing/entity/cost-sheet-entity";
import {MFGCostsEntity} from '../../costing/entity/mfg-costs-entity';
import { EnquiryProductCategoryEnum } from "@gtpl/shared-models/masters";

@Entity("enquiry_products")
export class EnquiryProdctsEntity {
    @PrimaryGeneratedColumn('increment',{
        name:"enquiry_product_id"
    }) 
    enquiryProductId: number;

    @Column('enum',{
        name:'category',
        enum:EnquiryProductCategoryEnum,
        nullable:false
    })
    category: EnquiryProductCategoryEnum

    @Column('int',{
        name:'brand_id',
        nullable:true
    })
    brandId: number

    @Column('int',{
        name:'variant_id',
        nullable:false
    })
    variantId: number

    @Column('int',{
        name:'pack_style_id',
        nullable:false
    })
    packStyleId: number

    @Column('enum',{
        name:'style_weighment',
        nullable:false,
        enum:StyleWeighmentEnum
    })
    styleWeighment: StyleWeighmentEnum

    @Column('decimal',{
        name:'unit_price',
        nullable:false,
        precision:10,scale:3,
        unsigned:true,
    })
    unitPrice: number

    @Column('int',{
        name:'no_of_case',
        nullable:false
    })
    noOfCase: number

    @Column('decimal',{
        name:'case_weight',
        nullable:false
    })
    caseWeight: number

    @Column('decimal',{
        name:'net_weight',
        nullable:false
    })
    netWeight: number

    @Column('decimal',{
        name:'net_amount',
        nullable:false
    })
    netAmount: number
    
    @Column('int',{
        name:'no_of_skewers',
        nullable:false
    })
    noOfSkewers: number
    
    @Column('int',{
        name:'variety_id',
        nullable:true
    })
    varietyId: number
    @Column('int',{
        name:'pack_count',
        nullable:false
    })
    packCount: number

    @Column('decimal',{
        name:'net_shrimp_weight',
        precision:10,
        scale:2,
        nullable:false
    })
    netShrimpWeight: number

    @Column('enum',{
        name:"order_type",
        nullable:false,
        enum:OrderTypeEnum
    })
    orderType: OrderTypeEnum
    @Column("int", {
        nullable: true,
        name: "uom_id"
      })
    uomId: number;

    @Column("decimal", {
        nullable: false,
        name: "pack_material_cost",
        precision:10,
        scale:2,
      })
    packMaterialCost: number;

    @Column('int',{
        name:'group',
        nullable:false
    })
    group: Number

    @Column('decimal',{
        name:'no_of_containers',
        nullable:false,
        precision:10,scale:1
    })
    noOfContainers: Number

    @Column('decimal',{
        name:'confirmed_containers',
        nullable:false,
        precision:10,scale:1
    })
    confirmedContainers: Number

    @Column('varchar',{
        name:'uv_price_category',
        nullable:true,
        length:50
    })
    uvPriceCategory: string

    @Column('varchar',{
        name:'uv_type',
        nullable:true,
        length:50
    })
    uvType: string
    
    @Column('int',{
        name:'uv_percent_or_cent',
        nullable:true
    })
    uvPercentOrCent: Number

    @Column('varchar',{
        name:'brand_type',
        nullable:false
    })
    brandType: string

    @Column("boolean", {
        name: 'is_so_created',
        default: false
    })
    isSocreated: boolean | null;

    @Column('int',{
        name:'price_based_on',
        nullable:false
    })
    priceBasedOn : number

    @ManyToOne(() => EnquiriesEntity,enquiries =>enquiries.enquiryProduct )
    @JoinColumn({name:'enquiry_id'})
    enquiryEntity:EnquiriesEntity


    @OneToMany(() =>CostSheetEntity ,costSheet => costSheet.enquiryProductEntity,{cascade:true})
    costSheet: CostSheetEntity[];
    @OneToMany(() =>MFGCostsEntity ,mfgCosts => mfgCosts.enquiryProducts,{cascade:true})
    mfgCosts: MFGCostsEntity[];
}